<template>
  <v-bottom-navigation
    grow
    fixed
    class="bottom-nav"
  >
    <BottomNavButton
      v-if="isMCD"
      route="/portal/feed"
      :routes="flattenedRoutes"
      icon="mdi-home-outline"
      :label="t('home')"
    />
    <BottomNavButton
      v-if="hasSchedulePerms"
      route="/wfm/portal/myschedule"
      :routes="flattenedRoutes"
      icon="mdi-calendar-blank-outline"
      :label="t('schedule')"
    />
    <BottomNavButton
      v-if="isMCD && hasPayPerms"
      route="/wfm/portal/mypay"
      :routes="flattenedRoutes"
      icon="mdi-currency-usd"
      :label="t('pay')"
    />
    <BottomNavButton
      v-if="hasRewardsPerms"
      route="/portal/crew/rewards"
      :routes="flattenedRoutes"
      icon="mdi-star-circle-outline"
      :label="t('rewards')"
    />
    <BottomNavButton
      v-if="isMCD && hasLeaderboardPerms"
      route="/portal/leaderboard"
      :routes="flattenedRoutes"
      icon="mdi-chart-box-outline"
      :label="t('leaderboard')"
    />
  </v-bottom-navigation>
</template>

<script setup>
  import { useRootStore } from '../../stores/root';
  import { storeToRefs } from 'pinia';
  import { computed, toRefs } from 'vue';
  import { useI18n } from 'vue-i18n';
  import BottomNavButton from './BottomNavButton.vue';
  const { t } = useI18n();
  const props = defineProps({
    routes: {
      type: Array,
      default: () => [],
    },
  });
  const { routes } = toRefs(props);
  const store = useRootStore();
  const { enterpriseClient, permissions, orgApps } = storeToRefs(store);
  const isMCD = computed(() => enterpriseClient.value === 'McDonalds');
  const hasSchedulePerms = computed(() => {
    return orgApps.value.includes('st_schedule');
  });
  const hasRewardsPerms = computed(() => {
    const orgHasRewards = orgApps.value.includes('st_rewards');
    const userHasRewards = permissions.value.includes('rewards_access');
    return orgHasRewards && userHasRewards;
  });
  const hasLeaderboardPerms = computed(() => {
    return orgApps.value.includes('st_leaderboard');
  });
  const hasPayPerms = computed(() => {
    return orgApps.value.includes('st_pay');
  });
  const flattenedRoutes = computed(() => {
    const reducer = (acc, route) => {
      if (route.children) {
        const children = route.children.reduce(reducer, []);
        acc.push(...children);
      }
      else if (route.path) {
        // strip the last / from the base url, so /admin/ => /admin, /admin => /admin, / => /
        const stripped = import.meta.env.BASE_URL.replace(/\/$/, '');
        const menuPath = import.meta.env.BASE_URL === '/' ? route.path : `${stripped}${route.path}`;
        acc.push({
          ...route,
          menuPath,
          // menuPath: `${import.meta.env.BASE_URL}${route.path}` // append the base path
        });
      }
      return acc;
    };
    return routes.value.reduce(reducer, []);
  });
</script>
<i18n>
{
  "en": {
    "home": "Home",
    "schedule": "Schedule",
    "pay": "Pay",
    "rewards": "Rewards",
    "leaderboard": "Leaderboard"
  },
  "es": {
    "home": "Inicio",
    "schedule": "Cronograma",
    "pay": "Pagar",
    "rewards": "Recompensas",
    "leaderboard": "Tabla de Clasificación"
  }
}
</i18n>
<style scoped>
.bottom-nav {
  text-align: center;
}
</style>
